/* The meditation, offered first. Rendered by sections/meditation-landing.liquid.

   One fixed stack of pictures (her world) sits behind the page. The scroll position decides which
   picture is seen, how close the camera stands, which words are lit, and when she speaks.
   Nothing here talks to the Oracle's services: the only requests are for this page's own media and
   the store's cart. */
(() => {
  'use strict';
  const root = document.getElementById('oml');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  let cfg = {};
  try { cfg = JSON.parse(document.getElementById('omlConfig').textContent); } catch (e) { cfg = {}; }

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saving = !!(navigator.connection && navigator.connection.saveData);
  const portraitMQ = matchMedia('(max-aspect-ratio: 4/5)');
  const coarse = matchMedia('(pointer: coarse)').matches;
  const clamp = (v, a = 0, b = 1) => (v < a ? a : v > b ? b : v);
  const lerp = (a, b, t) => a + (b - a) * t;
  const span = (v, a, b) => clamp((v - a) / (b - a || 1e-6));
  const smooth = (t) => t * t * (3 - 2 * t);
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  // The page is a plain, readable one until this script has taken hold, and again if it ever fails.
  const plain = () => { root.classList.add('oml--plain'); root.classList.remove('is-js'); };
  root.classList.remove('oml--plain');
  root.classList.add('is-js');
  try {

  /* ------------------------------------------------------------------ what is measured */
  function track(step, data) {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('meditation_landing_step', Object.assign({ step }, data || {})); } catch (e) { /* quiet */ }
    try { if (typeof window.sa_event === 'function') window.sa_event('meditation_' + step); } catch (e) { /* quiet */ }
  }

  /* ------------------------------------------------------------------ the scenes */
  const scenes = $$('.oml-scene').map((el) => ({
    el,
    name: el.dataset.scene,
    flow: el.classList.contains('oml-scene--flow'),
    voice: el.dataset.voice || '',
    pin: el.querySelector('.oml-pin'),
    top: 0, h: 0, pinH: 0, p: 0, raw: 0, enter: 0, seen: false,
    reveals: $$('[data-r]', el).map((r) => {
      if (r.querySelector('button, a, [tabindex]')) r.classList.add('has-controls');
      return { el: r, k: r.dataset.r.split(',').map(Number), o: -1, y: 0 };
    }),
  }));
  const S = {};
  scenes.forEach((s, i) => { s.i = i; S[s.name] = s; });

  let vw = innerWidth, vh = innerHeight, worldH = innerHeight, portrait = portraitMQ.matches;
  const world = $('.oml-world');
  function measure() {
    vw = innerWidth || 1; vh = innerHeight || 1; portrait = portraitMQ.matches;
    worldH = world.offsetHeight || vh;
    const sy = scrollY;
    scenes.forEach((s) => {
      const r = s.el.getBoundingClientRect();
      s.top = r.top + sy; s.h = r.height; s.pinH = s.pin ? s.pin.offsetHeight : vh;
    });
    sizeMotes();
  }

  /* ------------------------------------------------------------------ her world */
  const NAMES = ['threshold', 'wakes', 'eye', 'ink', 'bloom', 'petal', 'listens', 'hand', 'door', 'light', 'sees', 'path', 'hands', 'across', 'flame'];
  const SOLID = { threshold: 1, wakes: 1, eye: 1, ink: 1, petal: 1, listens: 1, hand: 1, door: 1, sees: 1, path: 1, hands: 1, across: 1, flame: 1 };
  const L = {};
  NAMES.forEach((n) => {
    const el = $('[data-layer="' + n + '"]');
    L[n] = { el, img: el.querySelector('img'), video: el.querySelector('video'), o: 0, sc: 1, tx: 0, ty: 0, dim: null, vis: null, lastO: -1, lastSc: -1, lastTx: 0, lastTy: 0, lastDim: -1, loaded: false, wanted: false };
  });
  // Which scene brings each picture, so it can be fetched a little before it is needed.
  const BRINGS = { threshold: 'threshold', wakes: 'wakes', eye: 'dive', bloom: 'dive', petal: 'idea', listens: 'arrive', hand: 'release', door: 'become', sees: 'leaves', path: 'questions', hands: 'listen', across: 'offer', flame: 'after' };

  function loadLayer(n) {
    const l = L[n];
    if (l.loaded) return;
    l.loaded = true;
    if (l.img && l.img.dataset.src) {
      l.img.src = (portrait && l.img.dataset.srcM) || l.img.dataset.src;
    }
    if (n === 'bloom') loadBloom();
  }
  function wantVideo(n, yes) {
    const l = L[n], v = l.video;
    if (!v || reduced || saving) return;
    if (yes) {
      if (!v.dataset.set) {
        v.dataset.set = '1';
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
        v.src = (portrait && v.dataset.srcM) || v.dataset.src;
      }
      if (v.paused && !l.wanted && !l.blocked) { l.wanted = true; const p = v.play(); if (p && p.catch) p.catch(() => { l.wanted = false; l.blocked = true; }); }
    } else if (l.wanted || !v.paused) {
      l.wanted = false;
      try { v.pause(); } catch (e) { /* quiet */ }
    }
  }

  // A phone saving power may refuse to play films until it is touched: try again then. The stills carry the page meanwhile.
  ['pointerdown', 'touchend', 'keydown'].forEach((ev) => addEventListener(ev, () => { NAMES.forEach((n) => { L[n].blocked = false; }); dirty = true; }, { passive: true }));

  /* the bloom: a flower that opens as the page is scrolled */
  const bloom = { frames: [], ready: 0, canvas: $('[data-layer="bloom"] canvas'), ctx: null, last: -1 };
  function loadBloom() {
    const urls = cfg.bloom || [];
    bloom.ctx = bloom.canvas.getContext('2d');
    urls.forEach((u, i) => {
      const im = new Image();
      im.decoding = 'async';
      im.onload = () => { bloom.frames[i] = im; bloom.ready++; if (bloom.last < 0 || Math.abs(bloom.last - i) < 1) drawBloom(bloom.want || 0, true); };
      // the first and the last come first: either can stand in for the rest
      im.src = u;
    });
  }
  function nearestFrame(i) {
    for (let d = 0; d < 41; d++) { if (bloom.frames[i - d]) return bloom.frames[i - d]; if (bloom.frames[i + d]) return bloom.frames[i + d]; }
    return null;
  }
  function drawBloom(f, force) {
    bloom.want = f;
    if (!bloom.ctx) return;
    const n = (cfg.bloom || []).length - 1;
    f = clamp(f, 0, n);
    if (!force && Math.abs(f - bloom.last) < 0.02) return;
    const a = Math.floor(f), b = Math.min(n, a + 1), t = f - a;
    const A = nearestFrame(a), B = bloom.frames[b] || A;
    if (!A) return;
    const c = bloom.ctx, w = bloom.canvas.width, h = bloom.canvas.height;
    c.globalAlpha = 1; c.drawImage(A, 0, 0, w, h);
    if (B && t > 0.01) { c.globalAlpha = t; c.drawImage(B, 0, 0, w, h); c.globalAlpha = 1; }
    bloom.last = f;
  }

  /* how far the eye must grow for her pupil to fill the screen */
  function pupilFill() {
    const iw = portrait ? 1080 : 2560, ih = portrait ? 1920 : 1440;
    const cover = Math.max(vw / iw, worldH / ih);
    const r = (portrait ? 0.1905 : 0.0598) * iw * cover;
    return Math.max(4, (0.5 * Math.hypot(vw, worldH) / r) * 1.18);
  }

  /* where her eye sits on the screen in the waking picture, and the point that picture grows from */
  function eyeAt() {
    const iw = portrait ? 1080 : 2560, ih = portrait ? 1920 : 1440;
    const ex = portrait ? 0.677 : 0.5555, ey = 0.415, fx = 0.5, fy = 0.41;
    const c = Math.max(vw / iw, worldH / ih), dw = iw * c, dh = ih * c;
    return { x: (vw - dw) * fx + ex * dw, y: (worldH - dh) * fy + ey * dh, ox: vw * fx, oy: worldH * fy };
  }

  /* ------------------------------------------------------------------ the motes in her light */
  const motes = { c: $('.oml-motes'), x: null, list: [], w: 0, h: 0, level: 1, t: 0 };
  function sizeMotes() {
    if (reduced || !motes.c) return;
    const dpr = Math.min(1.5, devicePixelRatio || 1);
    motes.w = vw; motes.h = worldH;
    motes.c.width = Math.round(vw * dpr); motes.c.height = Math.round(worldH * dpr);
    motes.x = motes.c.getContext('2d'); motes.x.setTransform(dpr, 0, 0, dpr, 0, 0);
    const n = Math.round(clamp((vw * worldH) / 26000, 18, 54));
    while (motes.list.length < n) motes.list.push(newMote(true));
    motes.list.length = n;
  }
  function newMote(anywhere) {
    return { x: Math.random() * motes.w, y: anywhere ? Math.random() * motes.h : motes.h + 10, r: 0.5 + Math.random() * 1.7, a: 0.05 + Math.random() * 0.28, vy: 3 + Math.random() * 9, vx: (Math.random() - 0.5) * 5, ph: Math.random() * 6.28, sp: 0.2 + Math.random() * 0.5 };
  }
  function drawMotes(dt) {
    if (reduced || !motes.x) return;
    const x = motes.x; motes.t += dt;
    x.clearRect(0, 0, motes.w, motes.h);
    if (motes.level < 0.02) return;
    for (let i = 0; i < motes.list.length; i++) {
      const m = motes.list[i];
      m.y -= m.vy * dt; m.x += (m.vx + Math.sin(motes.t * m.sp + m.ph) * 4) * dt;
      if (m.y < -10 || m.x < -10 || m.x > motes.w + 10) motes.list[i] = newMote(false);
      const tw = 0.6 + 0.4 * Math.sin(motes.t * m.sp * 2 + m.ph);
      x.globalAlpha = m.a * tw * motes.level;
      x.fillStyle = motes.warm ? '#ffe2b0' : '#e9dcff';
      x.beginPath(); x.arc(m.x, m.y, m.r, 0, 6.2832); x.fill();
    }
    x.globalAlpha = 1;
  }

  /* ------------------------------------------------------------------ words lit as the page is read */
  const scrubs = $$('[data-scrub]').map((el) => {
    const words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    const spans = words.map((w, i) => { const sp = document.createElement('span'); sp.textContent = w; el.appendChild(sp); if (i < words.length - 1) el.appendChild(document.createTextNode(' ')); return sp; });
    return { el, spans, k: el.dataset.scrub.split(',').map(Number), last: [], scene: el.closest('.oml-scene').dataset.scene };
  });
  function runScrub(sc, p) {
    const t = span(p, sc.k[0], sc.k[1]), n = sc.spans.length, head = t * (n + 4);
    for (let i = 0; i < n; i++) {
      const a = Math.round((0.2 + 0.8 * smooth(clamp((head - i) / 4))) * 50) / 50;
      if (sc.last[i] !== a) { sc.last[i] = a; sc.spans[i].style.setProperty('--a', a); }
    }
  }

  /* ------------------------------------------------------------------ one frame */
  const bar = $('#omlBar');
  let past = null, lightOn = null, flowOn = null, activeName = '', lastShade = 1;
  function render(y) {
    for (let i = 0; i < scenes.length; i++) {
      const s = scenes[i];
      s.raw = (y - s.top) / Math.max(1, s.h - (s.flow ? vh : s.pinH));
      s.p = clamp(s.raw);
      s.enter = i === 0 ? 1 : smooth(span(y, s.top - vh * 0.9, s.top - vh * 0.22));
    }
    const still = reduced ? 0 : 1;
    const dp = S.dive.p, bp = S.become.p;

    // --- which pictures, how close
    L.threshold.o = 1; L.threshold.sc = 1 + 0.14 * easeOut(S.threshold.p) * still;
    L.wakes.o = S.wakes.enter;
    {
      // The camera travels into her eye: the picture grows from her eye while her eye drifts to the middle,
      // so the close picture of the eye can take its place without a jump.
      const base = 1.02 + 0.06 * S.wakes.p * still;
      const zoom = still ? Math.exp(Math.log(13) * Math.pow(span(dp, 0, 0.17), 2)) : 1;
      const drift = still ? easeInOut(span(dp, 0, 0.14)) : 0;
      const e = eyeAt(), sc = base * zoom;
      const bx = e.ox + base * (e.x - e.ox), by = e.oy + base * (e.y - e.oy);
      L.wakes.sc = sc;
      L.wakes.tx = lerp(bx, vw * 0.499, drift) - e.ox - sc * (e.x - e.ox);
      L.wakes.ty = lerp(by, worldH * 0.499, drift) - e.oy - sc * (e.y - e.oy);
    }
    L.eye.o = smooth(span(dp, 0.09, 0.17));
    L.eye.sc = still ? Math.exp(Math.log(pupilFill()) * easeInOut(span(dp, 0.1, 0.58))) : 1;
    L.ink.o = smooth(span(dp, 0.5, 0.6)) * (S.idea.enter < 1 ? 1 : 0);
    L.bloom.o = smooth(span(dp, 0.6, 0.7));
    L.petal.o = S.idea.enter; L.petal.sc = 1.02 + 0.1 * S.idea.p * still;
    L.petal.dim = lerp(0.16, 0.62, smooth(span(S.idea.p, 0.02, 0.14))) - 0.14 * smooth(span(S.idea.p, 0.74, 0.86)) + (S.maker ? 0.16 * S.maker.enter : 0);
    L.listens.o = S.arrive.enter; L.listens.sc = 1.02 + 0.07 * S.arrive.p * still;
    L.hand.o = S.release.enter; L.hand.sc = 1.02 + 0.09 * S.release.p * still;
    L.door.o = S.become.enter;
    L.door.sc = still ? (1.02 + 0.05 * span(bp, 0, 0.45)) * Math.exp(Math.log(2.5) * Math.pow(span(bp, 0.42, 0.96), 2)) : 1;
    L.light.o = smooth(span(bp, 0.5, 0.86)) * (S.leaves.enter < 1 ? 1 : 0);
    L.sees.o = S.leaves.enter; L.sees.sc = 1.02 + 0.06 * S.leaves.p * still; L.sees.dim = 0.42;
    L.path.o = S.questions.enter;
    L.path.sc = still ? 1 + 0.5 * (smooth(span(S.questions.p, 0.2, 0.34)) + smooth(span(S.questions.p, 0.42, 0.56)) + smooth(span(S.questions.p, 0.63, 0.77))) / 3 + 0.06 * S.questions.p : 1;
    L.path.dim = 0.22 + 0.18 * smooth(span(S.questions.p, 0.84, 0.92));
    L.hands.o = S.listen.enter; L.hands.sc = 1.02 + 0.05 * S.listen.p * still; L.hands.dim = 0.6;
    L.across.o = S.offer.enter; L.across.sc = 1.02 + 0.05 * S.offer.p * still; L.across.dim = 0.3;
    L.flame.o = S.after.enter; L.flame.sc = 1.02; L.flame.dim = 0.66;

    // --- fetch a picture two screens before it is seen
    for (const n in BRINGS) {
      const s = S[BRINGS[n]];
      if (!L[n].loaded && y > s.top - vh * 2.4) loadLayer(n);
    }

    // --- show only what can be seen
    let covered = false;
    for (let i = NAMES.length - 1; i >= 0; i--) {
      const n = NAMES[i], l = L[n];
      const vis = l.o > 0.002 && !covered;
      if (vis !== l.vis) { l.vis = vis; l.el.style.visibility = vis ? 'visible' : 'hidden'; l.el.classList.toggle('is-vis', vis); if (!vis) { l.el.style.opacity = '0'; l.lastO = 0; } }
      if (vis) {
        const o = Math.round(l.o * 1000) / 1000;
        if (o !== l.lastO) { l.lastO = o; l.el.style.opacity = o; }
        if (l.img && (Math.abs(l.sc - l.lastSc) > 0.0004 || Math.abs(l.tx - l.lastTx) > 0.2 || Math.abs(l.ty - l.lastTy) > 0.2)) {
          l.lastSc = l.sc; l.lastTx = l.tx; l.lastTy = l.ty;
          l.el.style.transform = (Math.abs(l.tx) > 0.05 || Math.abs(l.ty) > 0.05 ? 'translate3d(' + l.tx.toFixed(1) + 'px,' + l.ty.toFixed(1) + 'px,0) ' : '') + 'scale(' + l.sc.toFixed(4) + ')';
        }
        if (l.dim != null) { const d = Math.round(l.dim * 100) / 100; if (d !== l.lastDim) { l.lastDim = d; l.el.style.setProperty('--dim', d); } }
      }
      if (l.video) wantVideo(n, vis && l.o > 0.05);
      if (SOLID[n] && l.o >= 0.999) covered = true;
    }
    if (L.bloom.vis) drawBloom(span(dp, 0.62, 0.96) * ((cfg.bloom || []).length - 1));

    // --- the words of each scene
    let act = '', inFlow = false;
    for (let i = 0; i < scenes.length; i++) {
      const s = scenes[i];
      // screens of scroll before this scene's words come to rest (negative), and since they began to leave
      const pre = (y - s.top) / vh, post = (y - (s.top + s.h - s.pinH)) / vh;
      const near = pre > -1.2 && post < 1.2;
      if (s.flow && y > s.top - vh * 0.3 && y < s.top + s.h - vh * 0.12) inFlow = true;
      if (s.flow ? (y > s.top - vh * 0.55 && y < s.top + s.h - vh * 0.5) : ((i === 0 || pre >= -0.12) && post <= 0.05)) act = s.name;
      for (let j = 0; j < s.reveals.length; j++) {
        const r = s.reveals[j], k = r.k;
        let o = 0, ty = 0;
        if (near) {
          // "0,0" arrives as the scene scrolls into place; "1,1" leaves as the scene scrolls away.
          // Anything else is lit and dimmed while the scene is held.
          const comes = k[0] === 0 && k[1] === 0, goes = k[2] >= 1 && k[3] >= 1;
          const a = comes ? (i === 0 ? 1 : smooth(span(pre, -0.42, -0.08))) : smooth(span(s.p, k[0], k[1]));
          const b = goes ? 1 - smooth(span(post, 0.05, 0.4)) : 1 - smooth(span(s.p, k[2], k[3]));
          o = Math.min(a, b);
          ty = reduced ? 0 : a < 1 ? (comes ? 0 : (1 - a) * 22) : (goes ? 0 : -(1 - b) * 22);
        }
        o = Math.round(o * 200) / 200;
        if (o !== r.o) {
          r.o = o; r.el.style.opacity = o;
          r.el.classList.toggle('is-off', o < 0.01);
        }
        const tyr = Math.round(ty * 2) / 2;
        if (tyr !== r.y) { r.y = tyr; r.el.style.transform = tyr ? 'translate3d(0,' + tyr + 'px,0)' : ''; }
      }
    }
    for (let i = 0; i < scrubs.length; i++) { const sc = scrubs[i], s = S[sc.scene]; if (s.raw > -0.3 && s.raw < 1.3) runScrub(sc, s.p); }

    // --- the room around the words
    motes.level = clamp(1 - L.ink.o * (1 - L.petal.o) - 0.5 * L.sees.o * (1 - L.path.o));
    motes.warm = L.door.o > 0.5 && L.sees.o < 0.5;
    const nowPast = y > S.threshold.top + Math.max(1, S.threshold.h - S.threshold.pinH) * 0.76;
    if (nowPast !== past) { past = nowPast; root.classList.toggle('is-past', past); updateBar(); }
    const shade = Math.round((1 - 0.94 * L.light.o * (1 - L.sees.o)) * 100) / 100;
    if (shade !== lastShade) { lastShade = shade; world.style.setProperty('--shade', shade); }
    const nowLight = L.light.o > 0.55 && L.sees.o < 0.6;
    if (nowLight !== lightOn) { lightOn = nowLight; root.classList.toggle('is-light', lightOn); }
    if (inFlow !== flowOn) { flowOn = inFlow; root.classList.toggle('is-flow', flowOn); }
    if (act !== activeName) { activeName = act; onScene(act); }
  }

  /* ------------------------------------------------------------------ the loop */
  let cur = scrollY, target = scrollY, lastT = performance.now(), dirty = true, drawn = false;
  function loop(t) {
    const dt = Math.min(0.1, (t - lastT) / 1000); lastT = t;
    target = scrollY;
    const k = reduced ? 1 : 1 - Math.exp(-dt / (coarse ? 0.05 : 0.11));
    const before = cur;
    cur += (target - cur) * k;
    if (Math.abs(target - cur) < 0.3) cur = target;
    if (dirty || cur !== before) {
      dirty = false;
      if (drawn) render(cur);
      else { try { render(cur); drawn = true; } catch (e) { plain(); throw e; } }
    }
    drawMotes(dt);
    tickVoice(t);
    requestAnimationFrame(loop);
  }

  /* ------------------------------------------------------------------ things that simply appear */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-seen'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    $$('[data-see]').forEach((el) => io.observe(el));
  } else { $$('[data-see]').forEach((el) => el.classList.add('is-seen')); }

  /* ------------------------------------------------------------------ the bar that leads to the bag */
  let cardSeen = false, lastSeen = false;
  function updateBar() {
    if (!bar) return;
    const on = !!past && !cardSeen && !lastSeen;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    const b = bar.querySelector('button'); if (b) b.tabIndex = on ? 0 : -1;
    root.style.setProperty('--bar', past ? '78px' : '0px');
  }
  if (bar && 'IntersectionObserver' in window) {
    const io2 = new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.target.classList.contains('oml-cta')) cardSeen = e.isIntersecting; else lastSeen = e.isIntersecting; });
      updateBar();
    }, { threshold: 0.2 });
    const c = $('.oml-cta'), l2 = $('.oml-last'); if (c) io2.observe(c); if (l2) io2.observe(l2);
  }

  /* ------------------------------------------------------------------ her voice */
  const A = { ctx: null, on: false, master: null, bedGain: null, voiceGain: null, bedSrc: null, buffers: {}, played: {}, speaking: null, sample: null };
  const BED = 0.5, BED_DUCK = 0.2;
  const soundBtn = $('#omlSound'), caption = $('#omlCaption');
  function initAudio() {
    if (A.ctx) return true;
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return false;
    try {
      A.ctx = new C();
      A.master = A.ctx.createGain(); A.master.gain.value = 0; A.master.connect(A.ctx.destination);
      A.bedGain = A.ctx.createGain(); A.bedGain.gain.value = 0; A.bedGain.connect(A.master);
      A.voiceGain = A.ctx.createGain(); A.voiceGain.gain.value = 1; A.voiceGain.connect(A.master);
      return true;
    } catch (e) { A.ctx = null; return false; }
  }
  function ramp(param, v, secs) {
    const t = A.ctx.currentTime;
    try { param.cancelScheduledValues(t); param.setValueAtTime(param.value, t); param.linearRampToValueAtTime(v, t + secs); } catch (e) { param.value = v; }
  }
  function buffer(url) {
    if (!A.buffers[url]) {
      A.buffers[url] = fetch(url).then((r) => { if (!r.ok) throw new Error('audio'); return r.arrayBuffer(); })
        .then((b) => new Promise((res, rej) => A.ctx.decodeAudioData(b, res, rej)));
      A.buffers[url].catch(() => { delete A.buffers[url]; });
    }
    return A.buffers[url];
  }
  async function startBed() {
    if (A.bedSrc || !cfg.bed) return;
    try {
      const b = await buffer(cfg.bed.url);
      if (A.bedSrc || !A.on) return;
      const src = A.ctx.createBufferSource();
      src.buffer = b; src.loop = true; src.loopStart = cfg.bed.loopStart; src.loopEnd = Math.min(cfg.bed.loopEnd, b.duration);
      src.connect(A.bedGain); src.start(0, cfg.bed.loopStart);
      A.bedSrc = src;
      ramp(A.bedGain.gain, A.sample ? underSample() : A.speaking ? BED_DUCK : BED, 3.2);
    } catch (e) { /* she can still be read */ }
  }
  function setSoundUi() {
    if (soundBtn) { soundBtn.textContent = A.on ? 'Sound on' : 'Sound off'; soundBtn.setAttribute('aria-pressed', A.on ? 'true' : 'false'); }
    root.classList.toggle('is-sound', A.on);
    root.style.setProperty('--cap', A.on ? (vw < 560 ? '60px' : '70px') : '0px');
  }
  async function soundOn(opts) {
    if (!initAudio()) { toast('This browser cannot play her voice. Her words are on the page.'); return false; }
    try { await A.ctx.resume(); } catch (e) { /* quiet */ }
    A.on = true; setSoundUi();
    ramp(A.master.gain, 1, 0.6);
    startBed();
    track('sound_on');
    if (!opts || !opts.quiet) voiceFor(activeName);
    return true;
  }
  function soundOff() {
    if (!A.ctx) return;
    A.on = false; setSoundUi();
    stopSpeaking(0.3); stopSample(true);
    ramp(A.master.gain, 0, 0.4);
    setTimeout(() => { if (!A.on && A.ctx) A.ctx.suspend().catch(() => {}); }, 500);
    track('sound_off');
  }
  function showCaption(text) {
    if (!caption) return;
    if (!text) { caption.classList.remove('is-on'); return; }
    caption.textContent = text; caption.classList.add('is-on');
  }
  function stopSpeaking(fade) {
    const sp = A.speaking; if (!sp) return;
    A.speaking = null;
    try { ramp(sp.gain.gain, 0, fade || 0.3); sp.src.stop(A.ctx.currentTime + (fade || 0.3) + 0.05); } catch (e) { /* quiet */ }
    A.played[sp.id] = false; // cut short: she may say it again if they return
    A.pauseUntil = performance.now() + (fade || 0.3) * 1000 + 300; // a breath before she speaks again
    showCaption('');
    if (A.bedGain && !A.sample) ramp(A.bedGain.gain, BED, 1.2);
  }
  async function speak(id, at) {
    const line = cfg.voice && cfg.voice[id];
    if (!line || !A.on || A.sample || A.speaking) return;
    A.played[id] = true;
    const token = (A.token = (A.token || 0) + 1);
    let b;
    try { b = await buffer(line.url); } catch (e) { A.played[id] = false; return; }
    if (!A.on || A.token !== token || A.speaking || A.sample) { A.played[id] = false; return; }
    const src = A.ctx.createBufferSource(), g = A.ctx.createGain();
    src.buffer = b; g.gain.value = 1; src.connect(g); g.connect(A.voiceGain);
    A.speaking = { id, src, gain: g, at: at == null ? -1 : at };
    ramp(A.bedGain.gain, BED_DUCK, 0.5);
    showCaption(line.text);
    src.onended = () => {
      if (!A.speaking || A.speaking.src !== src) return;
      A.speaking = null; showCaption('');
      if (!A.sample) ramp(A.bedGain.gain, BED, 1.6);
      A.pauseUntil = performance.now() + 700;
    };
    src.start();
    track('voice_' + id);
  }
  // She speaks once someone has stayed with a scene for a moment; never over herself.
  let dwell = { name: '', since: 0 };
  function onScene(name) {
    dwell = { name, since: performance.now() };
    const s = S[name];
    if (s && !s.seen) { s.seen = true; track('scene_' + name); }
    if (!s) return;
    // If the reader has walked two scenes past what she is saying, she lets it go.
    if (A.sample && S.listen && Math.abs(s.i - S.listen.i) >= 2) stopSample(true);
    if (A.speaking && A.speaking.at >= 0 && Math.abs(s.i - A.speaking.at) >= 2) stopSpeaking(0.8);
  }
  function voiceFor(name) {
    const s = S[name];
    if (s && s.voice && !A.played[s.voice]) speak(s.voice, s.i);
  }
  function tickVoice(t) {
    if (!A.on || A.sample || A.speaking) return;
    if (A.pauseUntil && t < A.pauseUntil) return;
    if (!dwell.name || t - dwell.since < 500) return;
    voiceFor(dwell.name);
  }
  if (soundBtn) soundBtn.addEventListener('click', () => { if (A.on) soundOff(); else soundOn(); });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) { lastT = performance.now(); dirty = true; }
    if (!A.ctx) return;
    if (document.hidden) A.ctx.suspend().catch(() => {});
    else if (A.on) A.ctx.resume().catch(() => {});
  });

  /* an example, to be heard: a minute of the meditation made for Maya, beside what she told the Oracle */
  const playBtn = $('#omlPlay'), hearCap = $('#omlHearCap'), hearAt = $('#omlHearAt'), ringP = $('.oml-ring-p');
  const HEAR_IDLE = hearCap ? hearCap.textContent : '';
  const PLAY_LABEL = playBtn ? playBtn.getAttribute('aria-label') : '';
  const told = $$('[data-told]');
  // The example carries its own music, so the page's music steps out while it plays.
  function underSample() { return cfg.opening && cfg.opening.music ? 0 : 0.3; }
  // Which moment is playing: when in her twenty minutes, and which of Maya's words it answers.
  function setMoment(m) {
    const text = m ? m[1] + ' · ' + m[2] : '', key = m ? m[3] : '';
    if (hearAt && hearAt.dataset.t !== text) { hearAt.dataset.t = text; if (text) hearAt.textContent = text; hearAt.classList.toggle('is-on', !!text); }
    for (let i = 0; i < told.length; i++) told[i].classList.toggle('is-on', !!key && told[i].dataset.told === key);
  }
  function setHear(text) {
    if (!hearCap || hearCap.dataset.t === text) return;
    hearCap.dataset.t = text; hearCap.classList.add('is-out');
    setTimeout(() => { if (hearCap.dataset.t === text) { hearCap.textContent = text; hearCap.classList.remove('is-out'); } }, 380);
  }
  function stopSample(reset) {
    const sm = A.sample; if (!sm) return;
    A.sample = null;
    const at = Math.min(sm.dur, sm.offset + (A.ctx.currentTime - sm.t0));
    try { ramp(sm.gain.gain, 0, 0.35); sm.src.stop(A.ctx.currentTime + 0.4); } catch (e) { /* quiet */ }
    cancelAnimationFrame(sm.raf);
    A.sampleAt = reset ? 0 : at;
    if (playBtn) { playBtn.setAttribute('aria-pressed', 'false'); playBtn.setAttribute('aria-label', PLAY_LABEL); }
    if (reset) { if (ringP) ringP.style.strokeDashoffset = 100; setHear(HEAR_IDLE); setMoment(null); }
    if (A.bedGain && A.on) ramp(A.bedGain.gain, BED, 1.4);
  }
  async function playSample() {
    if (!cfg.opening) return;
    if (!A.on) { const ok = await soundOn({ quiet: true }); if (!ok) return; }
    stopSpeaking(0.3);
    let b;
    try { b = await buffer(cfg.opening.url); } catch (e) { toast('Her voice could not be reached. Please try again.'); return; }
    if (A.sample || !A.on) return;
    const offset = A.sampleAt && A.sampleAt < b.duration - 0.5 ? A.sampleAt : 0;
    const src = A.ctx.createBufferSource(), g = A.ctx.createGain();
    src.buffer = b; g.gain.value = 0; src.connect(g); g.connect(A.voiceGain);
    const sm = (A.sample = { src, gain: g, t0: A.ctx.currentTime, offset, dur: b.duration, raf: 0 });
    ramp(g.gain, 1, 0.25); ramp(A.bedGain.gain, underSample(), 0.6);
    src.onended = () => {
      if (A.sample !== sm) return;
      A.sample = null; A.sampleAt = 0; cancelAnimationFrame(sm.raf);
      playBtn.setAttribute('aria-pressed', 'false'); playBtn.setAttribute('aria-label', PLAY_LABEL);
      if (ringP) ringP.style.strokeDashoffset = 0;
      setHear(cfg.opening.after || 'The rest is written from your words.'); setMoment(null);
      ramp(A.bedGain.gain, BED, 2);
      track('sample_end');
    };
    src.start(0, offset);
    playBtn.setAttribute('aria-pressed', 'true'); playBtn.setAttribute('aria-label', 'Pause');
    const caps = cfg.opening.captions || [], moments = cfg.opening.moments || [];
    const tick = () => {
      if (A.sample !== sm) return;
      const at = sm.offset + (A.ctx.currentTime - sm.t0);
      if (ringP) ringP.style.strokeDashoffset = 100 - 100 * clamp(at / sm.dur);
      let line = '', moment = null;
      for (let i = 0; i < caps.length; i++) if (at >= caps[i][0] - 0.15) line = caps[i][1];
      for (let i = 0; i < moments.length; i++) if (at >= moments[i][0]) moment = moments[i];
      if (line) setHear(line);
      setMoment(moment);
      sm.raf = requestAnimationFrame(tick);
    };
    tick();
    track('sample_play');
  }
  if (playBtn) playBtn.addEventListener('click', () => { if (A.sample) stopSample(false); else playSample(); });

  /* ------------------------------------------------------------------ entering */
  let gliding = 0;
  function glideTo(y, ms) {
    if (reduced) { scrollTo(0, y); return; }
    const from = scrollY, t0 = performance.now(), id = ++gliding;
    const stop = () => { gliding++; };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach((e) => addEventListener(e, stop, { once: true, passive: true }));
    const step = (t) => {
      if (id !== gliding) return;
      const k = clamp((t - t0) / ms);
      scrollTo(0, lerp(from, y, easeInOut(k)));
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  const enterTo = () => S.wakes.top + Math.max(1, S.wakes.h - S.wakes.pinH) * 0.32;
  const es = $('#omlEnterSound'), ei = $('#omlEnterSilent');
  if (es) es.addEventListener('click', async () => { track('enter_sound'); await soundOn(); glideTo(enterTo(), 5200); });
  if (ei) ei.addEventListener('click', () => { track('enter_silent'); glideTo(enterTo(), 3600); });

  /* ------------------------------------------------------------------ the bag */
  const toastEl = $('#omlToast');
  let toastT = 0;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 4200);
  }
  let buying = false;
  async function buy(btn) {
    if (buying) return;
    const variant = Number(root.dataset.variant);
    if (!variant || root.dataset.canBuy !== 'true') return;
    buying = true;
    const buttons = $$('[data-oml-buy]'); buttons.forEach((b) => { b.disabled = true; });
    const place = btn.closest('.oml-bar') ? 'bar' : btn.closest('.oml-card') ? 'offer' : btn.closest('.oml-top') ? 'top' : 'end';
    track('add_to_bag', { place });
    // The store's own paths (a market or a language may put a prefix before them).
    const base = (root.dataset.root || '/').replace(/\/?$/, '/');
    const cartUrl = root.dataset.cartUrl || base + 'cart';
    const addUrl = root.dataset.cartAddUrl || base + 'cart/add';
    const json = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    try {
      // If it is already waiting in the bag (from here, or from a reading), it is not added twice.
      let has = false;
      try {
        const cart = await fetch(cartUrl + '.js', { headers: json, credentials: 'same-origin' }).then((r) => r.json());
        has = (cart.items || []).some((i) => Number(i.variant_id) === variant);
      } catch (e) { has = false; }
      if (!has) {
        const res = await fetch(addUrl + '.js', {
          method: 'POST', credentials: 'same-origin', headers: Object.assign({ 'Content-Type': 'application/json' }, json),
          body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: { _Origin: 'meditation page' } }] }),
        });
        if (!res.ok) throw new Error('bag');
      }
      if (root.dataset.designMode === 'true') { buying = false; buttons.forEach((b) => { b.disabled = false; }); toast('In the bag. (The editor stays on this page.)'); return; }
      location.href = root.dataset.afterAdd === 'checkout' ? base + 'checkout' : cartUrl;
    } catch (e) {
      buying = false; buttons.forEach((b) => { b.disabled = false; });
      toast('Your bag could not be updated. Please try again.');
      track('add_to_bag_failed', { place });
    }
  }
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-oml-buy]'); if (b) { e.preventDefault(); buy(b); return; }
    const a = e.target.closest('[data-oml-about]'); if (a) { e.preventDefault(); openAbout(); }
  });
  addEventListener('pageshow', (e) => { if (e.persisted) { buying = false; $$('[data-oml-buy]').forEach((b) => { b.disabled = false; }); } });

  /* ------------------------------------------------------------------ a little clarity */
  const about = $('#omlAbout');
  function openAbout() {
    if (!about) return;
    track('about_open');
    if (about.showModal) about.showModal(); else about.setAttribute('open', '');
  }
  if (about) {
    const close = () => { if (about.close) about.close(); else about.removeAttribute('open'); };
    const cb = $('#omlAboutClose'); if (cb) cb.addEventListener('click', close);
    about.addEventListener('click', (e) => { if (e.target === about) close(); });
  }

  /* ------------------------------------------------------------------ begin */
  let rz = 0;
  const remeasure = () => { clearTimeout(rz); rz = setTimeout(() => { const was = portrait; measure(); if (was !== portrait) swapForShape(); dirty = true; }, 120); };
  function swapForShape() {
    // A turned phone: fetch the pictures cut for the new shape.
    NAMES.forEach((n) => {
      const l = L[n];
      if (l.loaded && l.img && l.img.dataset.src) l.img.src = (portrait && l.img.dataset.srcM) || l.img.dataset.src;
      if (l.video && l.video.dataset.set) { l.video.classList.remove('is-playing'); l.video.addEventListener('playing', () => l.video.classList.add('is-playing'), { once: true }); l.video.src = (portrait && l.video.dataset.srcM) || l.video.dataset.src; l.wanted = false; }
    });
  }
  addEventListener('resize', remeasure, { passive: true });
  addEventListener('orientationchange', remeasure, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { measure(); dirty = true; });
  addEventListener('load', () => { measure(); dirty = true; });
  measure();
  setSoundUi();
  updateBar();
  track('view');
  render(cur); drawn = true; dirty = false;
  requestAnimationFrame(loop);
  } catch (e) { plain(); throw e; }
})();
